import { classes } from "./hmcConfig";
import {
  getTranslation as t,
  getTranslationWithParams as tp,
} from "./translations";
import {
  gigyaFormSend,
  gigyaSaveAnswers,
} from "./gigya";
import { log } from "./logger";
import { settings } from "./settings";
import ClipboardJS from "clipboard";

import "/css/registrationForm.scss";

export const registrationTemplate = () => {
  return `<div class="${classes.registration.title}">${t(
    "hmc.registration.form.title"
  )}</div><div class="${classes.registration.body}">${t(
    "hmc.registration.form.body"
  )}</div><form id="hmc-gigya-form"><div class="${
    classes.registration.form
  }"><div class="${classes.registration.field}"><input type="text" class="${
    classes.registration.input
  }" placeholder="${t(
    "hmc.registration.form.name"
  )}" name="name"><span class="error">${t(
    "hmc.registration.form.mandatory"
  )}</span></div><div class="${
    classes.registration.field
  }"><input type="text" class="${classes.registration.input}" placeholder="${t(
    "hmc.registration.form.surname"
  )}" name="surname"><span class="error">${t(
    "hmc.registration.form.mandatory"
  )}</span></div><div class="${classes.registration.field} ${
    classes.registration.field
  }--email"><input type="email" class="${
    classes.registration.input
  }"placeholder="${t(
    "hmc.registration.form.email"
  )}" name="email"><span class="error">${t(
    "hmc.registration.form.mandatory"
  )}</span></div></div><div class="${classes.registration.form}">
  <div class="${classes.registration.form} ${classes.registration.field} ${
    classes.registration.field
  }--privacy"><div>${t(
    "hmc.registration.form.privacyDisclaimer"
  )}</div><label for="hmc-gigya-form-privacy"><input id="hmc-gigya-form-privacy" type="checkbox" value="1"> ${t(
    "hmc.registration.form.privacytext"
  )}</label><span class="error">${t(
    "hmc.registration.form.mandatory"
  )}</span></div></div>
  <div class="${
    classes.registration.form
  }"><input type="hidden" name="productTag" value="${settings.configuratorProducts?.join('|') || ''}"><input id="hmc-gigya-form-send" type="button" class="hmc-app__navigation__btn--next" value="${t(
    "hmc.registration.form.submit"
  )}"></div></form>`;
};

export const prefillFormAndSaveAnswers = (account) => {
  if (!((settings.registrationForm || forcePrintRegistationForm()) && !settings.app.registrationForm)) {
    return;
  }

  if (!account) {
    return;
  }

  log("trying to prefillFormAndSaveAnswers....", false, true);

  gigyaSaveAnswers(account);

  let checkForm = setInterval(() => {
    if (document.querySelector(`input.${classes.registration.input}[name=name]`)) {
      clearInterval(checkForm);
      document.querySelector(`input.${classes.registration.input}[name=name]`).value = account.profile.firstName;
      document.querySelector(`input.${classes.registration.input}[name=surname]`).value = account.profile.lastName;
      document.querySelector(`input.${classes.registration.input}[name=email]`).value = account.profile.email;
      Array.from(document.querySelectorAll(`input.${classes.registration.input}`)).forEach((el) => {
        el.disabled = true;
      });
      document
        .getElementById("hmc-gigya-form")
        .insertAdjacentHTML("beforeend",
          `<input type="hidden" name="name" value="${account.profile.firstName}">` +
          `<input type="hidden" name="surname" value="${account.profile.lastName}">` +
          `<input type="hidden" name="email" value="${account.profile.email}">`);
      const profiledCommunication = 'profiledCommunication' + DLG.gigya.country;
      if (
        account.preferences.hasOwnProperty(profiledCommunication) &&
        account.preferences[profiledCommunication].entitlements.includes(DLG.gigya.brand + DLG.gigya.country)
      ) {
        document.getElementById("hmc-gigya-form-privacy").checked = true;
      }
      log("prefillFormAndSaveAnswers done!", false, true);
    }
  }, 100);
};

export const formSendEvent = () => {
  document
    .getElementById("hmc-gigya-form-send")
    .addEventListener("click", formSend);
  document
    .querySelectorAll(`input.${classes.registration.input}`)
    .forEach((element) => {
      element.addEventListener("click", clearErrors);
    });
  document
    .getElementById("hmc-gigya-form-privacy")
    .addEventListener("click", clearCheckboxError);
};

const clearErrors = (el) => {
  el.target.parentElement.querySelector(".error").classList.remove("active");
};

const clearCheckboxError = (el) => {
  el.target.parentElement.parentElement
    .querySelector(".error")
    .classList.remove("active");
};

const formSend = (el) => {
  const formData = Object.fromEntries(
    new FormData(document.getElementById("hmc-gigya-form"))
  );
  if (isFormValid()) {
    el.target.disabled = true;
    el.target.classList.add("disabled");
    gigyaFormSend(formData);
  }
};

const isFormValid = () => {
  let v = 0;
  if (!isPrivacyChecked()) {
    v = -1;
  }
  const formData = Array.from(
    new FormData(document.getElementById("hmc-gigya-form"))
  );

  formData.forEach((element) => {
    if (element[1] != "") {
      v++;
      if (element[0] == "email") {
        if (!validateEmail(element[1])) {
          setFieldError(element[0]);
          v--;
        }
      }
    } else {
      setFieldError(element[0]);
    }
  });
  return v === formData.length ? true : false;
};

const isPrivacyChecked = () => {
  if (!settings.registrationFormPrivacyMandatory) return true;
  const el = document.getElementById("hmc-gigya-form-privacy");
  if (el.checked) return true;
  setCheckboxError(el);
};

const setFieldError = (name) => {
  log("MADATORY: " + name);
  let el = document.querySelector(
    `input.${classes.registration.input}[name=${name}]`
  );
  if (el) el.parentElement.querySelector(".error").classList.add("active");
};

const setCheckboxError = (el) => {
  log("MADATORY: checkbox", false, true);
  if (el)
    el.parentElement.parentElement
      .querySelector(".error")
      .classList.add("active");
};

function validateEmail(mail) {
  if (
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
      mail
    )
  ) {
    return true;
  }
  return false;
}

export const printThankYouPage = () => {
  let thankYouPage = thankYouTemplate();
  document.querySelector("." + classes.registration.wrapper).innerHTML =
    thankYouPage;
  const clipboard = new ClipboardJS(".copyToClipboardBtn");
  clipboard.on("success", function (e) {
    document.querySelector(".copyToClipboardBtn").innerHTML = `${t(
      "hmc.registration.form.thankyou.copy"
    )} &nbsp;&nbsp;<i class="fa-solid fa-check"></i>`;
  });
};

const thankYouTemplate = () => {
  const date = new Date();
  date.setDate(date.getDate() + 30);
  const dateString = date.toLocaleDateString();
  if (t("hmc.registration.form.thankyou.copy") ==  "hideBTN") {
    return `<div class="${classes.registration.thankyou.title}">${t(
      "hmc.registration.form.thankyou.title"
    )}</div><div class="${classes.registration.thankyou.body}">${t(
      "hmc.registration.form.thankyou.body"
    )} <strong>${t("hmc.registration.form.coupon")}</strong></div>
    <div class="${classes.registration.thankyou.note}"> ${tp(
      "hmc.registration.form.thankyou.note",
      { 0: dateString }
    )}</div>`;
  } else {
    return `<div class="${classes.registration.thankyou.title}">${t(
      "hmc.registration.form.thankyou.title"
    )}</div><div class="${classes.registration.thankyou.body}">${t(
      "hmc.registration.form.thankyou.body"
    )} <strong>${t("hmc.registration.form.coupon")}</strong></div>
    <div class="${
      classes.registration.thankyou.copy
    }"><button class="hmc-app__navigation__btn--next copyToClipboardBtn" data-clipboard-text="${t(
      "hmc.registration.form.coupon"
    )}">${t("hmc.registration.form.thankyou.copy")}</button></div>
    <div class="${classes.registration.thankyou.note}"> ${tp(
      "hmc.registration.form.thankyou.note",
      { 0: dateString }
    )}</div>`;
  }
};

export const anchorEvent = () => {
  if (document.getElementById("hmc-results-anchor"))
    document
      .getElementById("hmc-results-anchor")
      .addEventListener("click", scrollToForm);
};

const scrollToForm = () => {
  const hForm =
    document.querySelector(".hmc-app__registration-form").offsetTop -
    document.querySelector("header").offsetHeight;
  window.scrollTo({ top: hForm, behavior: "smooth" });
};

export const forcePrintRegistationForm = () => {
  let result = false;
  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Array.from(urlSearchParams.entries());
  params.forEach((param) => {
    if (param[0] == "registrationForm") result = true;
  });
  return result;
};
